<template>
  <div class="NavBar" style="width: 1920px;z-index: 1">
    <Row class="MainSelect">
      <Col class="menucol">
        <div v-on:click="goIn(0, NavOpen.one)" style="margin-top: 60px">
          <div>
            <div class="textarea">
              <div
                v-bind:class="{
                  textAn: !NavOpen.one,
                  textAnIn: NavOpen.one,
                  whitetext: WhiteText[0],
                  aboutOpen: NavOpen.one
                }"
              >
                <p class="Tnumber">01</p>
                <p class="title">關於我們</p>
              </div>
              <div
                v-bind:class="{
                  'animated fadeOutRight fast': NavOpen.one,
                  'animated fadeInRight fast': !NavOpen.one
                }"
              >
                <img src="../assets/b01.png" />
              </div>
            </div>

            <div
              v-bind:class="{
                selecttion1: !NavOpen.one,
                selecttionIn1: NavOpen.one
              }"
            >
              <div
                v-if="NavOpen.one"
                v-bind:class="{ 'animated fadeInUp fast': NavOpen.one }"
              >
                <img src="../assets/b02.png" />
              </div>
            </div>
            <div
              class="loading"
              v-bind:class="{
                'animated fadeIn fast': NavOpen.one,
                'animated fadeOut fast': !NavOpen.one
              }"
            ></div>
          </div>
        </div>
      </Col>
      <Col class="menucol">
        <div v-on:click="goIn(1, NavOpen.two)" style="margin-top: 60px">
          <div>
            <div class="textarea">
              <div
                v-bind:class="{
                  textAn: !NavOpen.two,
                  textAnIn: NavOpen.two,
                  whitetext: WhiteText[1]
                }"
              >
                <p class="Tnumber">02</p>
                <p class="title">多癌種放射線治療</p>
              </div>
              <div
                v-bind:class="{
                  'animated fadeOutRight fast': NavOpen.two,
                  'animated fadeInRight fast': !NavOpen.two
                }"
              >
                <img src="../assets/b01.png" />
              </div>
            </div>
            <div
              v-bind:class="{
                selecttion2: !NavOpen.two,
                selecttionIn2: NavOpen.two
              }"
            >
              <div
                v-if="NavOpen.two"
                v-bind:class="{ 'animated fadeInUp fast': NavOpen.two }"
              >
                <img src="../assets/b02.png" />
              </div>
            </div>
            <div
              class="loading"
              v-bind:class="{
                'animated fadeIn fast': NavOpen.two,
                'animated fadeOut fast': !NavOpen.two
              }"
            ></div>
          </div>
        </div>
      </Col>
      <Col class="menucol">
        <div v-on:click="goIn(2, NavOpen.three)" style="margin-top: 60px">
          <div>
            <div class="textarea">
              <div
                v-bind:class="{
                  textAn: !NavOpen.three,
                  textAnIn: NavOpen.three,
                  whitetext: WhiteText[2]
                }"
              >
                <p class="Tnumber">03</p>
                <p class="title">精準放射手術</p>
              </div>
              <div
                v-bind:class="{
                  'animated fadeOutRight fast': NavOpen.three,
                  'animated fadeInRight fast': !NavOpen.three
                }"
              >
                <img src="../assets/b01.png" />
              </div>
            </div>
            <div
              v-bind:class="{
                selecttion3: !NavOpen.three,
                selecttionIn3: NavOpen.three
              }"
            >
              <div
                v-if="NavOpen.three"
                v-bind:class="{ 'animated fadeInUp fast': NavOpen.three }"
              >
                <img src="../assets/b02.png" />
              </div>
            </div>
            <div
              class="loading"
              v-bind:class="{
                'animated fadeIn fast': NavOpen.three,
                'animated fadeOut fast': !NavOpen.three
              }"
            ></div>
          </div>
        </div>
      </Col>
      <Col class="menucol">
        <div v-on:click="goIn(3, NavOpen.four)" style="margin-top: 60px">
          <div>
            <div class="textarea">
              <div
                v-bind:class="{
                  textAn: !NavOpen.four,
                  textAnIn: NavOpen.four,
                  whitetext: WhiteText[3]
                }"
              >
                <p class="Tnumber">04</p>
                <p class="title">適應性治療</p>
              </div>
              <div
                v-bind:class="{
                  'animated fadeOutRight fast': NavOpen.four,
                  'animated fadeInRight fast': !NavOpen.four
                }"
              >
                <img src="../assets/b01.png" />
              </div>
            </div>
            <div
              v-bind:class="{
                selecttion4: !NavOpen.four,
                selecttionIn4: NavOpen.four
              }"
            >
              <div
                v-if="NavOpen.four"
                v-bind:class="{ 'animated fadeInUp fast': NavOpen.four }"
              >
                <img src="../assets/b02.png" />
              </div>
            </div>
            <div
              class="loading"
              v-bind:class="{
                'animated fadeIn fast': NavOpen.four,
                'animated fadeOut fast': !NavOpen.four
              }"
            ></div>
          </div>
        </div>
      </Col>
      <Col class="menucol">
        <div v-on:click="goIn(4, NavOpen.five)" style="margin-top: 60px">
          <div>
            <div class="textarea">
              <div
                v-bind:class="{
                  textAn: !NavOpen.five,
                  textAnIn: NavOpen.five,
                  whitetext: WhiteText[4]
                }"
              >
                <p class="Tnumber">05</p>
                <p class="title">質子治療</p>
              </div>
              <div
                v-bind:class="{
                  'animated fadeOutRight fast': NavOpen.five,
                  'animated fadeInRight fast': !NavOpen.five
                }"
              >
                <img src="../assets/b01.png" />
              </div>
            </div>
            <div
              v-bind:class="{
                selecttion5: !NavOpen.five,
                selecttionIn5: NavOpen.five
              }"
            >
              <div
                v-if="NavOpen.five"
                v-bind:class="{ 'animated fadeInUp fast': NavOpen.five }"
              >
                <img src="../assets/b02.png" />
              </div>
            </div>
            <div
              class="loading"
              v-bind:class="{
                'animated fadeIn fast': NavOpen.five,
                'animated fadeOut fast': !NavOpen.five
              }"
            ></div>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
// 顯示順序：01 瓦里安介紹 / 02 放射治療 / 03 精準放射治療 / 04 適應性治療 / 05 質子治療
const NAVKEYS = ["one", "two", "three", "four", "five"];
const NAVPATHS = [
  "/About",
  "/Radiation",
  "/Technology",
  "/Adaptive",
  "/Proton"
];

export default {
  name: "HelloWorld",
  props: {
    Target: Number,
    WhiteText: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      NavOpen: {
        one: false,
        two: false,
        three: false,
        four: false,
        five: false
      }
    };
  },
  watch: {
    Target: function() {
      this.TargetSet(this.Target);
    }
  },
  mounted() {
    this.TargetSet(this.Target);
  },
  methods: {
    TargetSet(t) {
      NAVKEYS.forEach((k, i) => {
        this.NavOpen[k] = i === t;
      });
    },
    ClickNav(t, b) {
      this.$emit("cellback", t);
      const key = NAVKEYS[t];
      if (!key) return;
      // 已展開的項目再點一次才進入該分類
      if (this.NavOpen[key]) {
        this.$router.push(NAVPATHS[t]);
        return;
      }
      NAVKEYS.forEach(k => {
        this.NavOpen[k] = k === key;
      });
    },

    goIn(t, v) {
      this.ClickNav(t, v);
    }
  }
};
</script>

<style scoped lang="scss">
.loading {
  height: 3px;

  background-color: #ec6604;
}

/* 由 Home 依底圖亮度自動判斷後傳入 */
.whitetext {
  color: #fff;
}

.Tnumber {
  font-size: 1.2rem;
  font-weight: 200;
}

.title {
  font-size: 1.6rem;
}

.textAn {
  margin-top: 0px;
  transition: all 0.8s;
}

/* 關於我們展開後文字疊在照片上，固定白字並加陰影避免被圖片吃掉 */
.aboutOpen {
  color: #fff;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.6);
}

.textAnIn {
  margin-top: -60px;
  transition: all 0.8s;
}

.NavBar {
  /*background-color: #ffffffcc;*/
  position: absolute;
  margin-top: 740px;
  height: 250px;
}

/* 未展開的細長狀態蓋一層橘色遮罩 */
.selecttion1,
.selecttion2,
.selecttion3,
.selecttion4,
.selecttion5 {
  position: relative;
}

.selecttion1::after,
.selecttion2::after,
.selecttion3::after,
.selecttion4::after,
.selecttion5::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(236, 102, 4, 0.7);
  pointer-events: none;
}

.selecttion1 {
  width: 100%;
  height: 30px;
  transition: all 0.8s;
  /*opacity: 0.5;*/
  background-image: url("../assets/n01.png");
  background-repeat: no-repeat;
  background-position: center;
}

.selecttion2 {
  width: 100%;
  height: 30px;
  /*opacity: 0.5;*/
  transition: all 0.8s;
  background-image: url("../assets/n02.png");
  background-repeat: no-repeat;
  background-position: center;
}

.selecttion3 {
  width: 100%;
  height: 30px;
  /*opacity: 0.5;*/
  transition: all 0.8s;
  background-image: url("../assets/n03.png");
  background-repeat: no-repeat;
  background-position: center;
}

.selecttion4 {
  width: 100%;
  height: 30px;
  /*opacity: 0.5;*/
  transition: all 0.8s;
  /* TODO: 換成 n05.png，目前沿用 n03.png 佔位 */
  background-image: url("../assets/n05.png");
  background-repeat: no-repeat;
  background-position: center;
}

.selecttionIn1 {
  text-align: center;
  background-image: url("../assets/n01.png");
  background-repeat: no-repeat;
  background-position: center;
  /*background-color: blueviolet;*/
  height: 250px;
  transition: all 0.5s ease-in-out;
  transition-delay: 0s;
  margin-top: -110px;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  /*opacity: 1;*/
}

.selecttionIn2 {
  background-image: url("../assets/n02.png");
  background-repeat: no-repeat;
  background-position: center;

  height: 250px;
  transition: all 0.5s ease-in-out;
  transition-delay: 0.1s;
  margin-top: -110px;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.selecttionIn3 {
  background-image: url("../assets/n03.png");
  background-repeat: no-repeat;
  background-position: center;

  height: 250px;
  transition: all 0.5s ease-in-out;
  transition-delay: 0.1s;
  margin-top: -110px;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.selecttionIn4 {
  /* TODO: 換成 n05.png，目前沿用 n03.png 佔位 */
  background-image: url("../assets/n05.png");
  background-repeat: no-repeat;
  background-position: center;

  height: 250px;
  transition: all 0.5s ease-in-out;
  transition-delay: 0.1s;
  margin-top: -110px;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.menucol {
  float: left;
  width: 20%;
}

.selecttion5 {
  width: 100%;
  height: 30px;
  transition: all 0.8s;
  background-image: url("../assets/n04.png");
  background-repeat: no-repeat;
  background-position: center;
}

.selecttionIn5 {
  background-image: url("../assets/n04.png");
  background-repeat: no-repeat;
  background-position: center;

  height: 250px;
  transition: all 0.5s ease-in-out;
  transition-delay: 0.1s;
  margin-top: -110px;
  padding: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.MainSelect {
  /*z-index: 1;*/
  position: absolute;
  width: 1920px;
}

.textarea {
  color: black;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /*font-size: 1.5rem;*/
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  width: 100%;
  padding: 0px 16px;
  /*padding-top: 750px;*/
}

.dvline {
  /*margin: 30px 0px;*/
  /*background-color: black;*/
  /*height: 2px;*/
  /*width: 200px;*/
}
</style>
